<template>
  <div class="home">
    <nav class="animated-text">
      <el-carousel :interval="5000" arrow="always">
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <img :src="item.pic" alt=""  @click="routerJump(item.link)">
        </el-carousel-item>
      </el-carousel>
      <div class="navBox">
        <p>累计服务企业 : <span>2000</span>+</p>
        <p>年撮合交易额超 : <span>50亿</span>+</p>
        <p>覆盖行业 : <span>20</span>+</p>
      </div>
    </nav>
    <section>
      <h5 class="animated-text">核心优势</h5>
      <div class="sectionContent">
        <div class="sectionBox animated-text">
          <img src="../../assets/img/homeList/sectionImg1.png" alt="">
          <p>降低成本</p>
          <span>全品类供应商竞价，打破信息壁垒，采购成本直降15%-30%</span>
        </div>
        <div class="sectionBox animated-text">
          <img src="../../assets/img/homeList/sectionImg2.png" alt="">
          <p>一站式服务</p>
          <span>需求发布-智能匹配-合同签约-物流跟踪-结算支付，全流程数字化</span>
        </div>
        <div class="sectionBox animated-text">
          <img src="../../assets/img/homeList/sectionImg3.png" alt="">
          <p>风控体系</p>
          <span>供应商资质三重认证 | 质量验厂报告可追溯 | 交易资金第三方监管</span>
        </div>
      </div>
    </section>
    <main>
      <h5>最新动态</h5>
      <div class="mainContent">
        <div class="mainBox animated-text">
          <h6>产品趋势</h6>
          <div>
            <p @click="switchTab(0)" :class="tableOneData.type === 1 ? 'chooseStyle' : ''">产品询价</p>
            <p @click="switchTab(1)" :class="tableOneData.type === 2 ? 'chooseStyle' : ''">产品竞价</p>
            <!-- <p>产品拼购</p> -->
          </div>
          <el-table height="216px" :data="tableOneData.tableOneList">
            <el-table-column prop="name" label="商品名称" align="left" min-width="40%">
              <template slot-scope="scope">
                <p class="textHidden">{{ scope.row.name }}</p>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="createTime" label="发布时间" align="left" min-width="30%">
              <template slot-scope="scope">
                <span class="textHidden">{{ !scope.row.createTime ? '-' : (scope.row.createTime).substring(0, 16) }}</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="count" label="报价企业数" align="right" min-width="30%">
              <template slot-scope="scope">
                <p>{{ scope.row.count }}<span>次</span></p>
              </template>
            </el-table-column>
            <div slot="empty" class="emptyBg">
              <span style="display: block; margin-top: 30%; font-weight: bold; font-size: 14px; color:rgba(0, 0, 0, .3)">暂无数据</span>
            </div>
          </el-table>
          <div class="mainFooter">
            <el-button @click="changeData(0)" class="defaultStyle">刷新数据</el-button>
            <el-button v-if="tableOneData.pages != 1" @click="changeData(1)" class="defaultStyle">换一批</el-button>
          </div>
          <img src="../../assets/img/homeList/mainBox.png" alt="">
        </div>
        <div class="mainBox animated-text">
          <h6>采购趋势</h6>
          <div>
            <p @click="switchTab(2)" :class="tableTwoData.type === 0 ? 'chooseStyle' : ''">询价次数</p>
            <p @click="switchTab(3)" :class="tableTwoData.type === 1 ? 'chooseStyle' : ''">采购金额</p>
          </div>
          <el-table height="216px" :data="tableTwoData.tableTwoList">
            <el-table-column prop="name" label="公司名称" min-width="180px" align="left">
              <template slot-scope="scope">
                <p>{{ scope.row.name }}</p>
              </template>
            </el-table-column>
            <el-table-column v-if="tableTwoData.type === 0" prop="count" label="累计询价次数" min-width="100px" align="right">
              <template slot-scope="scope">
                <p>{{ scope.row.count }}<span>次</span></p>
              </template>
            </el-table-column>
            <el-table-column v-else prop="moneyExt" label="累计金额" min-width="100px" align="right">
              <template slot-scope="scope">
                <p>{{ scope.row.moneyExt }}<span>元</span></p>
              </template>
            </el-table-column>
            <div slot="empty" class="emptyBg">
              <span style="display: block; margin-top: 30%; font-weight: bold; font-size: 14px; color:rgba(0, 0, 0, .3)">暂无数据</span>
            </div>
          </el-table>
          <div class="mainFooter">
            <el-button @click="changeData(2)" class="defaultStyle">刷新数据</el-button>
            <el-button v-if="tableTwoData.pages != 1" @click="changeData(3)" class="defaultStyle">换一批</el-button>
          </div>
          <img src="../../assets/img/homeList/mainBox.png" alt="">
        </div>
        <div class="mainBox animated-text">
          <h6>供应商趋势</h6>
          <div>
            <p @click="switchTab(4)" :class="tableThreeData.type === 0 ? 'chooseStyle' : ''">询价次数</p>
            <p @click="switchTab(5)" :class="tableThreeData.type === 1 ? 'chooseStyle' : ''">销售金额</p>
          </div>
          <el-table height="216px" :data="tableThreeData.tableThreeList">
            <el-table-column prop="name" label="公司名称" min-width="180px" align="left">
              <template slot-scope="scope">
                <p>{{ scope.row.name }}</p>
              </template>
            </el-table-column>
            <el-table-column v-if="tableThreeData.type == 0" prop="count" label="累计询价次数" align="right">
              <template slot-scope="scope">
                <p>{{ scope.row.count }}<span>次</span></p>
              </template>
            </el-table-column>
            <el-table-column v-else prop="moneyExt" label="累计金额" align="right">
              <template slot-scope="scope">
                <p>{{ scope.row.moneyExt }}<span>元</span></p>
              </template>
            </el-table-column>
            <div slot="empty" class="emptyBg">
              <span style="display: block; margin-top: 30%; font-weight: bold; font-size: 14px; color:rgba(0, 0, 0, .3)">暂无数据</span>
            </div>
          </el-table>
          <div class="mainFooter">
            <el-button @click="changeData(4)" class="defaultStyle">刷新数据</el-button>
            <el-button v-if="tableThreeData.pages != 1" @click="changeData(5)" class="defaultStyle">换一批</el-button>
          </div>
          <img src="../../assets/img/homeList/mainBox.png" alt="">
        </div>
      </div>
    </main>
    <footer>
      <h5 class="animated-text">数字化赋能</h5>
      <div class="footerContent animated-text"></div>
      <ul class="animated-text">
        <li>
          <p>商品数字化</p>
          <span>供应链具有大量非标准化产品，给所有行业参与者带来了高额的沟通及交易成本。推动海量SKU参数的标准化及统一化，进而建立供应链上的统一“语言体系”，解决商品参数不统一、商品类别不全的问题。</span>
        </li>
        <li>
          <p>采购数字化</p>
          <span>传统的采购既繁琐又不透明，数字化采购平台根据行业和客户的特性，提供专属服务，能够帮助企业以标准化、自动化的形式下单，减少对于销售代表的依赖。</span>
        </li>
        <li>
          <p>履约数字化</p>
          <span>低效的库存管理及物流服务是企业面临的共同挑战，利用数据分析及智能决策系统，根据成本、库存地点及供货量、配送时间、服务质量以及结算期等主要变量，制定最优的履约计划。</span>
        </li>
        <li>
          <p>运营数字化</p>
          <span>提供全方位闭环数字化服务，囊括预算制定、采购计划、交易管理和售后服务全周期。</span>
        </li>
      </ul>
    </footer>
  </div>
</template>
<script>
import { homeCountApi, homePurchaseApi, homeAmountApi, homeSupplyApi, homeSupplyAmountApi, getBannerApi } from '@/api/index'
export default {
  props: {},
  data() {
    return {
      bannerList: [],
      tableOneData: {
        current: 1,
        size: 4,
        pages: 2,
        tableOneList: [],
        type: 1
      },
      tableTwoData: {
        current: 1,
        size: 4,
        pages: 2,
        tableTwoList: [],
        type: 0
      },
      tableThreeData: {
        current: 1,
        size: 4,
        pages: 2,
        tableThreeList: [],
        type: 0
      },
      mainIndex: 0
    }
  },
  created() {
  },
  mounted() {
    this.getBanner()
    this.observeText()
    this.getHomeCount()
    this.getHomePurchase()
    this.getHomeSupply()
  },
  methods: {
    // 获取广告图
    async getBanner() {
      const { data: res } = await getBannerApi(1)
      if (res.code !== 200) return this.$message.error(res.message)
      this.bannerList = res.result
    },
    observeText() {
      const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1 // 当元素进入视口的10%时触发
      };
      const observerCallback = (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      };
      const observer = new IntersectionObserver(observerCallback, observerOptions);
      document.querySelectorAll('.animated-text').forEach(text => {
        observer.observe(text);
      });
    },
    routerJump(url) {
      if (url != '') {
        window.open(url, '_blank')
      }
    },
    switchTab(val) {
      if (val == 0) {
        this.tableOneData.type = 1
        this.getHomeCount('reset')
      } else if (val == 1) {
        this.tableOneData.type = 2
        this.getHomeCount('reset')
      } else if (val == 2) {
        this.tableTwoData.type = 0
        this.getHomePurchase('reset')
      } else if (val == 3) {
        this.tableTwoData.type = 1
        this.getHomePurchase('reset')
      } else if (val == 4) {
        this.tableThreeData.type = 0
        this.getHomeSupply('reset')
      } else if (val == 5) {
        this.tableThreeData.type = 1
        this.getHomeSupply('reset')
      }
    },
    changeData(num) {
      if (num === 0) {
        this.getHomeCount('reset')
      } else if (num === 1) {
        if (this.tableOneData.current < this.tableOneData.pages) {
          this.tableOneData.current += 1
        } else {
          this.tableOneData.current = 1
        }
        this.getHomeCount()
      } else if (num === 2) {
        this.getHomePurchase('reset')
      } else if (num === 3) {
        if (this.tableTwoData.current < this.tableTwoData.pages) {
          this.tableTwoData.current += 1
        } else {
          this.tableTwoData.current = 1
        }
        this.getHomePurchase()
      } else if (num === 4) {
        this.getHomeSupply('reset')
      } else if (num === 5) {
        if (this.tableThreeData.current < this.tableThreeData.pages) {
          this.tableThreeData.current += 1
        } else {
          this.tableThreeData.current = 1
        }
        this.getHomeSupply()
      }
    },
    // 获取询价趋势列表
    async getHomeCount(reset) {
      if (reset ==='reset') {
        this.tableOneData.current = 1
      }
      const { data: res } = await homeCountApi(this.tableOneData)
      if (res.code === 200) {
        this.tableOneData.tableOneList = res.result.records
        this.tableOneData.pages = res.result.pages
      }
    },
    // 获取采购趋势列表
    async getHomePurchase(reset) {
      if (reset ==='reset') {
        this.tableTwoData.current = 1
      }
      if (this.tableTwoData.type === 0) {
        const { data: res } = await homePurchaseApi(this.tableTwoData)
        if (res.code === 200) {
          this.tableTwoData.tableTwoList = res.result.records
          this.tableTwoData.pages = res.result.pages
        }
      } else {
        const { data: res } = await homeAmountApi(this.tableTwoData)
        if (res.code === 200) {
          this.tableTwoData.tableTwoList = res.result.records
          this.tableTwoData.pages = res.result.pages
        }
      }
    },
    // 获取供应趋势列表
    async getHomeSupply(reset) {
      if (reset ==='reset') {
        this.tableThreeData.current = 1
      }
      if (this.tableThreeData.type === 0) {
        const { data: res } = await homeSupplyApi(this.tableThreeData)
        if (res.code === 200) {
          this.tableThreeData.tableThreeList = res.result.records
          this.tableThreeData.pages = res.result.pages
        }
      } else {
        const { data: res } = await homeSupplyAmountApi(this.tableThreeData)
        if (res.code === 200) {
          this.tableThreeData.tableThreeList = res.result.records
          this.tableThreeData.pages = res.result.pages
        }
      }
    },
    changeIndex(index) {
      this.mainIndex = index
    }
  },
}
</script>
<style scoped lang="less">
.home {
  .animated-text {
    opacity: 0;
    transform: translateY(20px);
    transition: opacity 0.5s ease, transform 0.5s ease;
  }
  .animated-text.visible {
    opacity: 1;
    transform: translateY(0);
  }
  nav {
    position: relative;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    cursor: pointer;
    /deep/ .el-carousel {
      width: 100%;
      aspect-ratio: 1920/800;
      .el-carousel__item {
        img {
          height: 100%;
        }
      }
      .el-carousel__container {
        height: 100%;
      }
      .el-carousel__indicators--horizontal {
        left: 20%;
        bottom: 5%;
        width: 35%;
        .el-carousel__indicator--horizontal {
          margin-right: 1vw;
          padding: 0;
          width: 12%;
          .el-carousel__button {
            height: 1vh; 
            width: 100%;
            background-color: rgba(228, 228, 228, 1);
          }
        }
        .is-active .el-carousel__button {
          background-color: black;
        }
      }
    }
    .navBox {
      position: absolute;
      right: 0;
      bottom: 4%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 60%;
      z-index: 9999;
      p {
        width: 33.3%;
        font-size: 16px;
        font-weight: bold;
        span {
          margin-left: 4px;
          font-size: 24px;
        }
      }
    }
  }
  section {
    padding: 48px;
    width: 100%;
    height: 430px;
    background-color: #fff;
    box-sizing: border-box;
    h5 {
      margin: 0 0 48px;
      font-size: 32px;
    }
    .sectionContent {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      .sectionBox {
        width: calc(33.3% - 24px);
        img {
          margin-bottom: 24px;
          width: 100%;
        }
        p {
          margin-bottom: 6px;
          font-size: 20px;
          font-weight: bold;
        }
        span {
          color: rgba(0, 0, 0, 0.60);
          font-weight: bold;
          font-size: 14px;
        }
      }
    }
  }
  main {
    padding: 48px;
    width: 100%;
    height: 630px;
    box-sizing: border-box;
    background-color: rgba(245, 246, 247, 1);
    h5 {
      margin: 0 0 48px;
      font-size: 32px;
    }
    .mainContent {
      display: flex;
      justify-content: space-between;
      .mainBox {
        position: relative;
        padding: 32px 0;
        width: calc(33.3% - 12px);
        height: 442px;
        box-sizing: border-box;
        background-color: #fff;
        box-shadow: 0px 0px 16px 0px #DCDCDC;
        h6 {
          margin: 0 24px;
          font-size: 20px;
          color: rgba(0, 0, 0, 0.80);
        }
        >div:nth-child(2) {
          margin-top: 16px;
          padding: 0 24px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          box-sizing: border-box;
          border-bottom: 1px solid rgba(0, 0, 0, 0.10);
          >p {
            margin-right: 16px;
            margin-bottom: 23px;
            width: 88px;
            height: 32px;
            background-color: #fff;
            border: 1px solid rgba(0,0,0,0.1);
            box-sizing: border-box;
            cursor: pointer;
            color: rgba(0, 0, 0, 0.40);
            text-align: center;
            line-height: 30px;
            font-size: 14px;
            font-weight: bold;
            z-index: 10;
          }
          .chooseStyle {
            background-color: rgba(24, 144, 255, 0.10);
            border: 1px solid transparent;
            cursor: default;
            color: rgba(24, 144, 255, 1);
          }
        }
        /deep/ .el-table {
          margin: 12px 24px 24px;
          width: calc(100% - 48px);
          .el-table__cell {
            padding: 9.5px 0;
            >.cell {
              padding: 0;
              font-size: 14px;
            }
            p {
              font-size: 14px;
              color: rgba(0, 0, 0, 0.80);
              font-weight: bold;
            }
            span {
              font-size: 14px;
              color: rgba(0, 0, 0, 0.40);
              font-weight: bold;
            }
          }
        }
        .el-table::before {
          height: 0;
        }
        img {
          position: absolute;
          top: -15px;
          right: -15px;
          width: 100%;
          height: 442px;
        }
      }
      .mainFooter {
        display: flex;
        justify-content: center;
        .el-button {
          padding: 4px 8px;
          color: rgba(0, 0, 0, 0.40);
          font-size: 12px;
          z-index: 10;
        }
        .el-button:hover {
          color: rgba(0, 0, 0, 0.80);
        }
      }
    }
  }
  footer {
    padding: 48px;
    width: 100%;
    box-sizing: border-box;
    background-color: #fff;
    h5 {
      margin: 0 0 48px;
      font-size: 32px;
    }
    .footerContent {
      width: 100%;
      aspect-ratio: 1920/480;
      background-size: 100% auto;
      background-image: url('../../assets/img/homeList/footerBg.png');
    }
    >ul {
      display: flex;
      justify-content: space-between;
      width: 100%;
      li {
        margin-top: 48px;
        width: calc(25% - 24px);
        p {
          font-size: 20px;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.80);
        }
        span {
          font-size: 14px;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.60);
        }
      }
    }
  }
}
</style>
